import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogAnnouncmentsComponent } from './blog-announcments/blog-announcments.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    PipesModule
  ],
  declarations: [
    BlogAnnouncmentsComponent
  ],
  exports: [
    BlogAnnouncmentsComponent
  ]
})
export class BlogAnnouncementsModule { }
